import { useLocation } from 'react-router';
import { useSession } from '../../auth';
import { useDemo } from '../../../demo/DemoContext';
import { DEMO_DATE } from '../../../demo/data';
import { dateKey } from '../../../shared/lib/format';
import { resolveClientRegion, resolveRegion } from '../../../shared/i18n/region';

export function useWorkspace() {
  const demo = useDemo(); const { auth } = useSession();
  const isDemo = useLocation().pathname.startsWith('/demo/');
  const store = isDemo ? demo.store : auth?.store;
  const region = isDemo ? resolveRegion({ ...store, locale_id: store?.locale_id || 'vi_VN', country_code: store?.country_code || 'VN' }) : auth ? resolveRegion(store || {}) : resolveClientRegion(typeof navigator === 'undefined' ? [] : navigator.languages, typeof Intl === 'undefined' ? undefined : Intl.DateTimeFormat().resolvedOptions().timeZone);
  const timezone = region.timezone;
  return {
    isDemo, store, region, timezone, currency: region.currency, locale: region.locale, language: region.language, country: region.country,
    userName: isDemo ? 'Thắng Nguyễn' : auth?.user.full_name || auth?.user.username || 'Chủ cửa hàng',
    today: isDemo ? DEMO_DATE : dateKey(Date.now(), timezone),
    prefix: isDemo ? '/demo' : '/owner',
    scopeKey: [isDemo ? 'demo' : auth?.user.id, store?.tenant_id, store?.id],
  };
}
